import { CapoPlugin } from "/var/www/cellcom/production/frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];